import { UserType } from "@mcleod/core";
import { DataSource } from "@mcleod/components";
import { AutogenLayoutUserTableDataFusion } from "./autogen/AutogenLayoutUserTableDataFusion";
import { UserTableController  } from "./UserTableController";
import { UserTableLayout } from "./UserTableLayout";

export class UserTableDataFusion extends AutogenLayoutUserTableDataFusion implements UserTableLayout {
    public getSourceUsers(): DataSource {
        return this.sourceUserSettings;
    }

    public getUserType(): UserType {
        return UserType.DATAFUSION;
    }

    override onLoad(): void | Promise<void> {
        new UserTableController(this);
    }
}
